'use client';

import { useMousePosition } from "@/frontend/hooks/useMousePosition";
import { useState } from "react";
import './styles.scss';
import { ArrowExternal } from "@/frontend/components/ui/icons";
import { AnimatePresence, motion } from "motion/react";
import { useMediaQuery } from "@/frontend/hooks/useMediaQuery";
import { useElementEvent } from "@/frontend/hooks/useDocumentEvent";

export const MouseFollow = ({ mediaReference, inlineText }: MouseFollowTypes) => {
  const mousePos = useMousePosition();
  const [target, setTarget] = useState<string>('');
  const mediaQuery = useMediaQuery('(min-width: 1023px)');

  useElementEvent(mediaReference, 'mouseenter mouseleave', (event) => {
    if (event.type === 'mouseenter') return setTarget('container');
    return setTarget('');
  });

  return (
    <AnimatePresence>
      {(target === 'container' && mediaQuery) && <MouseFollowElement inlineText={inlineText} left={mousePos.clientX || 0} top={mousePos.clientY || 0} />}
    </AnimatePresence>
  );
};
MouseFollow.displayName = 'MouseFollow';

const MouseFollowElement = ({ left, top, inlineText }: MouseFollowElementTypes) => {
  return (
    <motion.div
      className="mouse-follow-element"
      style={{ x: left, y: top }}
      exit={{ scale: 0 }}
      initial={{ scale: 0, }}
      animate={{ scale: 1 }}
    >
      <div className="icon"><ArrowExternal color="var(--mouse-follow-icon__color)" /></div>
      <CircleText inlineText={inlineText} />
    </motion.div>
  )
};
MouseFollowElement.displayName = 'MouseFollowElement';


const CircleText = ({ inlineText }: { inlineText?: string }) => {
  const backupText = 'Visit project on external site.';
  return (
    <svg className="circle" viewBox="0 0 300 300" xmlSpace="preserve">
      <defs>
        <path id="circlePath" d="M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0 "/>
      </defs>
      <circle fill="none"/>
      <g>
        <use xlinkHref="#circlePath" fill="none"/>
        <text><textPath xlinkHref="#circlePath">{inlineText || backupText}</textPath></text>
      </g>
    </svg>
  );
};
CircleText.displayName = 'CircleText';

//
// Types
// -----------------------------------------------------------------------------

interface MouseFollowTypes {
  mediaReference: string;
  inlineText?: string;
};

interface MouseFollowElementTypes {
  left: number;
  top: number;
  inlineText?: string;
};